import React, { useState, useEffect } from "react";
import Layout from "../components/layouts/layout";
import RevealAnimation from "../components/RevealAnimation";
import Button from "../components/Button";
import TrustedPartner from "../components/trustedPartner";
import LPFooter from "../components/LPFooter";
import FAQSection from "../components/FAQSection";
import CaseStudiesSection from "../components/CaseStudiesSection";
import TwoColumnContactInfo from "../templates/TwoColumnContactInfo";
import Clm1Img from "../assets/Icons/phone.svg";
import Clm2Img from "../assets/Icons/mail.svg";
import BaskarImg from "../assets/Images/newAboutUs/baskar.png";
import "../components/decor/_decorSquares.scss";
import "./healthcare.scss";
import HeroImg from "../assets/Images/healthcare/health-care-bg.png";
const HealthcareLanding = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    message: "",
    serviceType: "healthcare-consultation",
  });

  // Handle UTM parameters
  useEffect(() => {
    if (typeof window !== "undefined") {
      const urlParams = new URLSearchParams(window.location.search);
      const utmSource = urlParams.get("utm_source");
      const utmMedium = urlParams.get("utm_medium");
      const utmCampaign = urlParams.get("utm_campaign");

      // Track the referral source for analytics
      if (utmSource && utmCampaign) {
        console.log("Healthcare page accessed via:", {
          utmSource,
          utmMedium,
          utmCampaign,
        });
        // You can add analytics tracking here
      }
    }
  }, []);

  const scrollToForm = () => {
    const formSection = document.getElementById("healthcare-form-section");
    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const downloadCapabilityDeck = () => {
    // For now, redirect to contact form - can be updated with actual PDF link
    scrollToForm();
  };

  const TwoColumnContactInfoData = {
    Clm1Img: Clm1Img,
    Clm1Title: "Phone:",
    Clm1SubTitle: "+44 (0) 161 706 7983",
    Clm2Img: Clm2Img,
    Clm2Title: "Email:",
    Clm2SubTitle: "hello@digiryte.com",
  };

  return (
    <Layout
      seo={{
        title: "Healthcare Digital Transformation | DigiRyte",
        ogtitle:
          "Healthcare Digital Transformation - HIPAA Compliant Solutions",
        description:
          "Transform healthcare with secure, compliant digital solutions. HIPAA/HITECH & NHS DTAC aligned platforms for hospitals, pharma, medtech & digital health innovators.",
        keywords:
          "healthcare digital transformation, HIPAA compliance, NHS DTAC, EHR integration, telehealth, medical devices, pharma tech, clinical trials",
      }}
      isLandingPage={false}
      pageUrl={"/healthcare"}
      redirectContactTo={"/healthcare#healthcare-form-section"}
      handleClick={scrollToForm}
    >
      <div className="healthcare-landing healthcare">
        {/* Hero Section */}
        <section className="healthcare-hero">
          <div className="decor-squares" aria-hidden="true">
            <span className="decor-square" style={{ top: 80, left: "5%" }} />
            <span
              className="decor-square lg"
              style={{ bottom: 100, right: "8%" }}
            />
            <span
              className="decor-square sm"
              style={{ top: "45%", right: "3%" }}
            />
          </div>

          <div className="hero-background">
            <div className="geometric-shapes">
              <div className="shape shape-1"></div>
              <div className="shape shape-2"></div>
              <div className="shape shape-3"></div>
            </div>
          </div>

          <div className="body-container">
            <div className="hero-wrapper">
              <div className="hero-content">
                <RevealAnimation component="h1" className="hero-title">
                  Healthcare Digital Transformation
                </RevealAnimation>
                <RevealAnimation component="div" className="hero-badge">
                  <span className="badge-text">
                    Enabled, Secure, Outcome‑Driven.
                  </span>
                </RevealAnimation>
                <RevealAnimation component="p" className="hero-subtitle">
                  Accelerate your digital transformation with secure, compliant
                  solutions. We deliver modern platforms that streamline
                  operations, elevate patient outcomes, and ensure HIPAA/HITECH
                  and NHS DTAC compliance from day one.
                </RevealAnimation>

                <RevealAnimation component="div" className="hero-cta-group">
                  <Button
                    label="Talk to Our Experts"
                    variant="contained"
                    color="primary"
                    customClassName="hero-cta-btn primary"
                    onClick={scrollToForm}
                  />
                </RevealAnimation>

                <RevealAnimation
                  component="div"
                  className="compliance-indicators"
                >
                  <div className="compliance-badge">
                    <span className="badge-icon">✓</span>
                    <span>HIPAA Compliant</span>
                  </div>
                  <div className="compliance-badge">
                    <span className="badge-icon">✓</span>
                    <span>NHS DTAC Aligned</span>
                  </div>
                  <div className="compliance-badge">
                    <span className="badge-icon">✓</span>
                    <span>HITECH Ready</span>
                  </div>
                </RevealAnimation>
              </div>

              <RevealAnimation component="div" className="hero-image">
                <img
                  src={HeroImg}
                  alt="Healthcare professional with digital technology"
                />
              </RevealAnimation>
            </div>
          </div>
        </section>

        <section className="who-we-serve-section">
          <div className="body-container">
            <RevealAnimation component="div" className="section-header">
              <h2>Who We Serve</h2>
              <p>
                We partner with healthcare organisations across the spectrum,
                from enterprise systems to innovative startups, delivering
                compliant, scalable digital solutions.
              </p>
            </RevealAnimation>

            <div className="serve-grid">
              <RevealAnimation component="div" className="serve-card">
                <div className="serve-icon">🏥</div>
                <h3>Enterprise Care Delivery</h3>
                <p>
                  Multi‑hospital systems, specialist & community clinics,
                  integrated care boards.
                </p>
              </RevealAnimation>

              <RevealAnimation component="div" className="serve-card">
                <div className="serve-icon">🧬</div>
                <h3>Life Sciences and Pharma</h3>
                <p>
                  R&D data platforms, clinical operations, safety and PV,
                  digital therapeutics, companion apps.
                </p>
              </RevealAnimation>

              <RevealAnimation component="div" className="serve-card">
                <div className="serve-icon">🚀</div>
                <h3>Startups and Scaleups</h3>
                <p>
                  B2C, B2B, B2B2C, and NHS + US launches seeking DTAC,
                  HIPAA/HITECH and clinical safety compliance.
                </p>
              </RevealAnimation>
            </div>
          </div>
        </section>

        {/* The Challenge Section */}
        <section className="healthcare-challenge-section">
          <div className="body-container">
            <RevealAnimation component="div" className="challenge-content">
              <div className="challenge-header">
                <RevealAnimation component="div" className="challenge-badge">
                  <span className="badge-icon">⚡</span>
                  <span className="badge-text">The Challenge</span>
                </RevealAnimation>

                <RevealAnimation component="h2" className="challenge-title">
                  Healthcare's Critical Transformation Imperative
                </RevealAnimation>
              </div>

              <RevealAnimation
                component="div"
                className="challenge-description"
              >
                <p>
                  Healthcare faces rising costs, burnout, and legacy tech debt.
                  Fragmented data and manual workflows delay decisions. Patients
                  demand digital‑first care; clinicians need tools that save
                  time, not add burden. Success requires the right platform,
                  data strategy, and operating model with compliance embedded
                  from day zero.
                </p>
              </RevealAnimation>

              {/* <div className="challenge-points">
                <RevealAnimation component="div" className="challenge-point">
                  <div className="point-icon">💰</div>
                  <div className="point-content">
                    <h4>Rising Costs & Resource Constraints</h4>
                    <p>
                      Healthcare organizations face mounting financial pressures
                      while needing to invest in digital transformation
                    </p>
                  </div>
                </RevealAnimation>

                <RevealAnimation component="div" className="challenge-point">
                  <div className="point-icon">🔧</div>
                  <div className="point-content">
                    <h4>Legacy Tech Debt & Fragmentation</h4>
                    <p>
                      Outdated systems create data silos and manual workflows
                      that delay critical clinical decisions
                    </p>
                  </div>
                </RevealAnimation>

                <RevealAnimation component="div" className="challenge-point">
                  <div className="point-icon">👩‍⚕️</div>
                  <div className="point-content">
                    <h4>Clinician Burnout & Workflow Burden</h4>
                    <p>
                      Healthcare professionals need intuitive tools that reduce
                      administrative load, not add complexity
                    </p>
                  </div>
                </RevealAnimation>

                <RevealAnimation component="div" className="challenge-point">
                  <div className="point-icon">📱</div>
                  <div className="point-content">
                    <h4>Patient Experience Expectations</h4>
                    <p>
                      Modern patients expect seamless, digital-first healthcare
                      experiences across all touchpoints
                    </p>
                  </div>
                </RevealAnimation>
              </div> */}

              {/* <RevealAnimation
                component="div"
                className="challenge-solution-bridge"
              >
                <div className="bridge-content">
                  <h3>The Solution:</h3>
                  <p>
                    Strategic digital transformation with{" "}
                    <strong>compliance-first architecture</strong>,
                    <strong> data-driven insights</strong>, and{" "}
                    <strong>human-centered design</strong>
                    that puts clinicians and patients first.
                  </p>
                </div>
              </RevealAnimation> */}
            </RevealAnimation>
          </div>
        </section>

        {/* Our Promise Section */}
        <section className="healthcare-promise-section">
          <div className="body-container">
            <RevealAnimation component="div" className="section-header">
              <h2>Our Promise</h2>
              <p>
                We deliver measurable outcomes through proven methodologies,
                enterprise-grade security, and comprehensive support that scales
                with your organization's growth.
              </p>
            </RevealAnimation>

            <div className="promise-grid">
              <RevealAnimation component="div" className="promise-item">
                <div className="promise-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle cx="12" cy="12" r="3" fill="currentColor" />
                  </svg>
                </div>
                <div className="promise-content">
                  <h4>Rapid Time‑to‑Value</h4>
                  <p>Via modular, cloud‑native architecture</p>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="promise-item">
                <div className="promise-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="3"
                      y="3"
                      width="7"
                      height="7"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <rect
                      x="3"
                      y="14"
                      width="7"
                      height="7"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <rect
                      x="14"
                      y="3"
                      width="7"
                      height="7"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <rect
                      x="14"
                      y="14"
                      width="7"
                      height="7"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <div className="promise-content">
                  <h4>Data‑Driven Insight</h4>
                  <p>For clinical & business teams</p>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="promise-item">
                <div className="promise-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <path
                      d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  </svg>
                </div>
                <div className="promise-content">
                  <h4>Seamless Workflows</h4>
                  <p>For patients, providers & administrators</p>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="promise-item">
                <div className="promise-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="5"
                      y="11"
                      width="14"
                      height="10"
                      rx="2"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <path
                      d="M8 11V7a4 4 0 0 1 8 0v4"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                    <circle cx="12" cy="16" r="1.5" fill="currentColor" />
                  </svg>
                </div>
                <div className="promise-content">
                  <h4>Enterprise‑Grade Security & Compliance</h4>
                  <p>UK NHS + US HIPAA/HITECH aligned</p>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="promise-item">
                <div className="promise-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <path
                      d="M12 6v6l4 2"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
                <div className="promise-content">
                  <h4>24×7 Support & Incident Response</h4>
                  <p>For ongoing operations and maintenance</p>
                </div>
              </RevealAnimation>

              <RevealAnimation
                component="div"
                className="promise-item promise-cta-card"
              >
                <div className="promise-cta-content">
                  <h4>Ready to Transform Your Healthcare Operations?</h4>
                  <p>Let's discuss how we can help you achieve your goals</p>
                  <Button
                    label="Talk to Our Experts"
                    variant="contained"
                    color="primary"
                    customClassName="promise-cta-btn"
                    onClick={() => (window.location.href = "/contact-us")}
                  />
                </div>
              </RevealAnimation>
            </div>
          </div>
        </section>

        {/* Service Offerings Section */}
        <section className="healthcare-offerings-section">
          <div className="body-container">
            <RevealAnimation component="div" className="section-header">
              <h2>Service Offerings</h2>
              <p>
                Comprehensive healthcare technology services designed to
                modernize your infrastructure, enhance patient care, and ensure
                regulatory compliance across UK and US markets.
              </p>
            </RevealAnimation>

            <div className="offerings-list">
              <RevealAnimation component="div" className="offering-card">
                <div className="offering-number">1</div>
                <div className="offering-content">
                  <h3>Platform and Cloud Modernisation</h3>
                  <p>
                    FHIR/HL7 APIs, microservices, multi‑region deployment for UK
                    & US compliance
                  </p>
                  <div className="offering-tags">
                    <span className="tag">FHIR/HL7</span>
                    <span className="tag">Microservices</span>
                    <span className="tag">Multi-Region</span>
                  </div>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="offering-card">
                <div className="offering-number">2</div>
                <div className="offering-content">
                  <h3>Data, Analytics and AI</h3>
                  <p>Predictive care and population health intelligence</p>
                  <div className="offering-tags">
                    <span className="tag">Predictive Analytics</span>
                    <span className="tag">Population Health</span>
                    <span className="tag">AI/ML</span>
                  </div>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="offering-card">
                <div className="offering-number">3</div>
                <div className="offering-content">
                  <h3>Digital Front Door and Engagement</h3>
                  <p>Mobile apps, telehealth, home‑care platforms</p>
                  <div className="offering-tags">
                    <span className="tag">Mobile Apps</span>
                    <span className="tag">Telehealth</span>
                    <span className="tag">Patient Engagement</span>
                  </div>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="offering-card">
                <div className="offering-number">4</div>
                <div className="offering-content">
                  <h3>Workflow Optimisation and DevSecOps</h3>
                  <p>Lean processes, RPA and security automation</p>
                  <div className="offering-tags">
                    <span className="tag">Process Automation</span>
                    <span className="tag">RPA</span>
                    <span className="tag">DevSecOps</span>
                  </div>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="offering-card">
                <div className="offering-number">5</div>
                <div className="offering-content">
                  <h3>Compliance and Governance</h3>
                  <p>HIPAA/HITECH, GDPR, ISO 27001, NHS DTAC, DCB0129/0160</p>
                  <div className="offering-tags">
                    <span className="tag">HIPAA/HITECH</span>
                    <span className="tag">NHS DTAC</span>
                    <span className="tag">ISO 27001</span>
                  </div>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="offering-card">
                <div className="offering-number">6</div>
                <div className="offering-content">
                  <h3>Support and Maintenance</h3>
                  <p>
                    24×7 incident response with SLA‑driven uptime and dedicated
                    on‑call teams
                  </p>
                  <div className="offering-tags">
                    <span className="tag">24/7 Support</span>
                    <span className="tag">SLA Driven</span>
                    <span className="tag">Incident Response</span>
                  </div>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="offering-card">
                <div className="offering-number">7</div>
                <div className="offering-content">
                  <h3>Managed Services and Continuous Improvement</h3>
                  <p>Operate and optimise securely at scale</p>
                  <div className="offering-tags">
                    <span className="tag">Managed Services</span>
                    <span className="tag">Optimization</span>
                    <span className="tag">Scalability</span>
                  </div>
                </div>
              </RevealAnimation>

              <RevealAnimation
                component="div"
                className="offering-card offering-cta-card"
              >
                <div className="offering-cta-content">
                  <h3>Ready to Get Started?</h3>
                  <p>
                    Let's discuss how our healthcare technology solutions can
                    transform your organization
                  </p>
                  <Button
                    label="Contact Our Healthcare Experts"
                    variant="contained"
                    color="primary"
                    customClassName="offering-cta-btn"
                    onClick={() => (window.location.href = "/contact-us")}
                  />
                </div>
              </RevealAnimation>
            </div>
          </div>
        </section>

        {/* Engagement Tracks Section */}
        <section className="healthcare-engagement-tracks">
          <div className="body-container">
            <RevealAnimation component="div" className="section-header">
              <h2>Engagement Tracks</h2>
              <p>
                Tailored approaches for enterprise transformation and startup
                acceleration, with compliance accelerators and co-investment
                opportunities for high-growth ventures.
              </p>
            </RevealAnimation>

            <div className="tracks-grid">
              <RevealAnimation component="div" className="track-card track-a">
                <div className="track-header">
                  <div className="track-label">Track A</div>
                  <h3>Enterprise Transformation</h3>
                </div>

                <div className="track-content">
                  <div className="track-sectors">
                    <span className="sector">Hospitals</span>
                    <span className="sector">ICBs</span>
                    <span className="sector">Pharma</span>
                    <span className="sector">Life Sciences</span>
                  </div>

                  <p className="track-focus">
                    Focused on efficiency, compliance and innovation.
                  </p>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="track-card track-b">
                <div className="track-header">
                  <div className="track-label">Track B</div>
                  <h3>Startups and Scaleups</h3>
                </div>

                <div className="track-content">
                  <div className="track-categories">
                    <div className="category">
                      <h4>B2C:</h4>
                      <p>wellness, Mntal‑Health, Rehab, Adherence apps.</p>
                    </div>

                    <div className="category">
                      <h4>B2B:</h4>
                      <p>
                        RPM Dashboards, Clinical Trial Automation,
                        Interoperability Gateways.
                      </p>
                    </div>

                    <div className="category">
                      <h4>B2B2C:</h4>
                      <p>Care Navigation & Insurer Benefit Marketplaces.</p>
                    </div>
                  </div>
                </div>
              </RevealAnimation>
            </div>

            <RevealAnimation component="div" className="founders-section">
              <div className="founders-content">
                <div className="founders-icon">🚀</div>
                <div className="founders-text">
                  <h3>For Founders</h3>
                  <p>
                    We co‑produce and co‑invest to accelerate go‑to‑market and
                    grant readiness.
                  </p>
                </div>
              </div>
            </RevealAnimation>
          </div>
        </section>

        {/* Co-Production & Co-Investment Section */}
        <section
          className="healthcare-coproduction"
          id="production-and-investment"
        >
          <div className="body-container">
            <RevealAnimation component="div" className="section-header">
              <h2>Co-Production and Co-Investment</h2>
              <p className="section-subtitle">Guided by TRL & Grants</p>
            </RevealAnimation>

            <RevealAnimation component="div" className="coproduction-intro">
              <p>
                We back founders with a flexible model blending fee‑for‑service
                and equity. Our team helps secure funding and grants such as:
              </p>
            </RevealAnimation>

            <div className="grants-and-trl-container">
              <RevealAnimation component="div" className="grants-section">
                <h3>Grant Opportunities</h3>
                <div className="grants-grid">
                  <div className="grant-item">
                    <div className="grant-icon">🇬🇧</div>
                    <span>Innovate UK Smart Grants</span>
                  </div>
                  <div className="grant-item">
                    <div className="grant-icon">🏥</div>
                    <span>NIHR i4i Programme</span>
                  </div>
                  <div className="grant-item">
                    <div className="grant-icon">🔬</div>
                    <span>SBRI Healthcare</span>
                  </div>
                  <div className="grant-item">
                    <div className="grant-icon">🧬</div>
                    <span>Biomedical Catalyst</span>
                  </div>
                  <div className="grant-item">
                    <div className="grant-icon">📱</div>
                    <span>Digital Health Technology Catalyst</span>
                  </div>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="trl-guidance-section">
                <h3>TRL Engagement Guidance</h3>
                <div className="trl-stages">
                  <div className="trl-stage">
                    <div className="trl-level">TRL 1‑3</div>
                    <div className="trl-content">
                      <h4>Concept & Early Development</h4>
                      <p>Concept, prototype, grant eligibility advice.</p>
                    </div>
                  </div>

                  <div className="trl-stage">
                    <div className="trl-level">TRL 4‑6</div>
                    <div className="trl-content">
                      <h4>Development & Validation</h4>
                      <p>MVP build, pilot, grant support + co‑funding.</p>
                    </div>
                  </div>

                  <div className="trl-stage">
                    <div className="trl-level">TRL 7‑9</div>
                    <div className="trl-content">
                      <h4>Scale & Commercialization</h4>
                      <p>Scale, certify, funding expansion, investment prep.</p>
                    </div>
                  </div>
                </div>
              </RevealAnimation>
            </div>

            <RevealAnimation component="div" className="support-statement">
              <p>
                We support partners to advance between TRL stages and qualify
                for larger grants and investments.
              </p>
            </RevealAnimation>
          </div>
        </section>

        {/* Our Delivery Principles Section */}
        <section className="healthcare-delivery-principles">
          <div className="body-container">
            <RevealAnimation component="div" className="section-header">
              <h2>Delivery Principles</h2>
              <p>
                Our commitment to excellence in healthcare technology delivery
              </p>
            </RevealAnimation>

            <div className="principles-grid">
              <RevealAnimation component="div" className="principle-card">
                <div className="principle-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2C9.243 2 7 4.243 7 7v3H6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5zm6 10l.002 8H6v-8h12zm-9-2V7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <h3>Secure and Privacy by Design</h3>
                <p>
                  Full compliance with HIPAA/HITECH, GDPR, and NHS DTAC
                  standards to protect patient data
                </p>
                <div className="principle-tags">
                  <span className="tag">HIPAA</span>
                  <span className="tag">GDPR</span>
                  <span className="tag">NHS DTAC</span>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="principle-card">
                <div className="principle-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm0 2v3H4V5h16zM4 19v-9h16l.002 9H4z"
                      fill="currentColor"
                    />
                    <circle cx="6.5" cy="16" r="1" fill="currentColor" />
                    <circle cx="9.5" cy="16" r="1" fill="currentColor" />
                    <circle cx="12.5" cy="16" r="1" fill="currentColor" />
                  </svg>
                </div>
                <h3>Interoperability First</h3>
                <p>
                  Seamless integration using industry standards like FHIR R4,
                  HL7, SNOMED CT, and ICD-10
                </p>
                <div className="principle-tags">
                  <span className="tag">FHIR R4</span>
                  <span className="tag">HL7</span>
                  <span className="tag">SNOMED CT</span>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="principle-card">
                <div className="principle-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83V6.31l6-2.12 6 2.12v4.78z"
                      fill="currentColor"
                    />
                    <path
                      d="M9.5 12.5l2 2 4-4"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h3>Clinical Safety Built In</h3>
                <p>
                  Comprehensive hazard logs and risk controls ensure patient
                  safety at every level
                </p>
                <div className="principle-tags">
                  <span className="tag">Risk Controls</span>
                  <span className="tag">Safety Standards</span>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="principle-card">
                <div className="principle-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm0 16H4V5h16v14z"
                      fill="currentColor"
                    />
                    <path
                      d="M6 7h12v2H6zm0 4h12v2H6zm0 4h7v2H6z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <h3>DevSecOps Automation and Observability</h3>
                <p>
                  Advanced automation and monitoring for Protected Health
                  Information and Personally Identifiable Information
                </p>
                <div className="principle-tags">
                  <span className="tag">PHI Protection</span>
                  <span className="tag">Automated</span>
                </div>
              </RevealAnimation>

              <RevealAnimation component="div" className="principle-card">
                <div className="principle-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                    />
                    <path
                      d="M12 6v6l4 2"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
                <h3>24×7 Incident Response and Continuous Monitoring</h3>
                <p>
                  Round-the-clock monitoring and rapid incident response to
                  ensure system reliability
                </p>
                <div className="principle-tags">
                  <span className="tag">24/7 Support</span>
                  <span className="tag">Real-time Monitoring</span>
                </div>
              </RevealAnimation>

              <RevealAnimation
                component="div"
                className="principle-card principle-cta-card"
              >
                <div className="principle-cta-content">
                  <div className="principle-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 2v.511l-8 6.223-8-6.222V6h16zM4 18V9.044l7.386 5.745a.994.994 0 001.228 0L20 9.044 20.002 18H4z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <h3>Ready to Build Healthcare Solutions?</h3>
                  <p>
                    Let's discuss how our delivery principles can power your
                    next healthcare innovation
                  </p>
                  <Button
                    label="Contact Our Team"
                    variant="contained"
                    color="primary"
                    customClassName="principle-cta-btn"
                    onClick={() => (window.location.href = "/contact-us")}
                  />
                </div>
              </RevealAnimation>
            </div>

            <RevealAnimation
              component="div"
              className="impact-outcomes-section"
            >
              <h3>Impact and Outcomes</h3>
              <p className="impact-subtitle">
                Measurable results that transform healthcare delivery
              </p>

              <div className="impact-categories">
                <RevealAnimation component="div" className="impact-card">
                  <div className="impact-number">30%</div>
                  <h4>Enterprises</h4>
                  <ul>
                    <li>30% less manual charting</li>
                    <li>40% faster decision support</li>
                    <li>25% lower run costs</li>
                  </ul>
                </RevealAnimation>

                <RevealAnimation component="div" className="impact-card">
                  <div className="impact-number">3-6</div>
                  <h4>Startups and Scaleups</h4>
                  <ul>
                    <li>Faster MVP in 3-6 months</li>
                    <li>70%+ grant success rate</li>
                    <li>Accelerated HIPAA and NHS readiness</li>
                  </ul>
                </RevealAnimation>

                <RevealAnimation component="div" className="impact-card">
                  <div className="impact-number">100%</div>
                  <h4>All Clients</h4>
                  <ul>
                    <li>Higher patient satisfaction</li>
                    <li>Enhanced data integrity</li>
                    <li>Improved trust and reliability</li>
                  </ul>
                </RevealAnimation>
              </div>
            </RevealAnimation>

            <RevealAnimation component="div" className="client-voices-section">
              <h3>Client Voices</h3>
              <p className="voices-subtitle">
                Hear from healthcare leaders who transformed their systems with
                us
              </p>

              <div className="testimonials-grid">
                <RevealAnimation component="div" className="testimonial-card">
                  <div className="quote-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 8H7c-1.103 0-2 .897-2 2v7c0 1.103.897 2 2 2h3c1.103 0 2-.897 2-2v-7c0-1.103-.897-2-2-2zm-3 9V10h3l.002 7H7zm10-9h-3c-1.103 0-2 .897-2 2v7c0 1.103.897 2 2 2h3c1.103 0 2-.897 2-2v-7c0-1.103-.897-2-2-2zm-3 9V10h3l.002 7H14z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <div className="testimonial-content">
                    <p>
                      Working with DigiRyte transformed our remote monitoring
                      service-50% drop in readmissions within 12 weeks.
                    </p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-info">
                      <strong>CIO</strong>
                      <span>Major Hospital Network</span>
                    </div>
                  </div>
                </RevealAnimation>

                <RevealAnimation component="div" className="testimonial-card">
                  <div className="quote-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 8H7c-1.103 0-2 .897-2 2v7c0 1.103.897 2 2 2h3c1.103 0 2-.897 2-2v-7c0-1.103-.897-2-2-2zm-3 9V10h3l.002 7H7zm10-9h-3c-1.103 0-2 .897-2 2v7c0 1.103.897 2 2 2h3c1.103 0 2-.897 2-2v-7c0-1.103-.897-2-2-2zm-3 9V10h3l.002 7H14z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <div className="testimonial-content">
                    <p>
                      They aligned NHS DTAC and Innovate UK requirements
                      seamlessly. Professional and highly knowledgeable team.
                    </p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-info">
                      <strong>Clinical Lead</strong>
                      <span>NHS Northern Trauma Network</span>
                    </div>
                  </div>
                </RevealAnimation>

                <RevealAnimation component="div" className="testimonial-card">
                  <div className="quote-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 8H7c-1.103 0-2 .897-2 2v7c0 1.103.897 2 2 2h3c1.103 0 2-.897 2-2v-7c0-1.103-.897-2-2-2zm-3 9V10h3l.002 7H7zm10-9h-3c-1.103 0-2 .897-2 2v7c0 1.103.897 2 2 2h3c1.103 0 2-.897 2-2v-7c0-1.103-.897-2-2-2zm-3 9V10h3l.002 7H14z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <div className="testimonial-content">
                    <p>
                      BreatheSure reached MVP in five months with DigiRyte's
                      co-production model. Incredible support and expertise.
                    </p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-info">
                      <strong>Lara</strong>
                      <span>Founder, BreatheSure</span>
                    </div>
                  </div>
                </RevealAnimation>
              </div>
            </RevealAnimation>
          </div>
        </section>

        {/* NHS & US Compliance Readiness Spotlight */}
        <section className="healthcare-compliance-spotlight" id="compliance">
          <div className="body-container">
            <div className="section-header">
              <h2>Compliance Readiness</h2>
              <p>
                Navigate complex healthcare regulations with confidence across
                UK, US, and international standards
              </p>
            </div>

            <div className="compliance-grid">
              <div className="compliance-card">
                <h3>UK Healthcare Standards</h3>
                <ul>
                  <li>DTAC</li>
                  <li>DCB0129/0160</li>
                  <li>DSPT</li>
                  <li>UK GDPR</li>
                </ul>
              </div>

              <div className="compliance-card">
                <h3>US Healthcare Standards</h3>
                <ul>
                  <li>HIPAA</li>
                  <li>HITECH</li>
                  <li>SOC 2</li>
                  <li>HITRUST</li>
                </ul>
              </div>

              <div className="compliance-card">
                <h3>International Standards</h3>
                <ul>
                  <li>ISO 27001</li>
                  <li>ISO 13485</li>
                </ul>
              </div>

              <div className="compliance-card">
                <h3>Medical Device Compliance</h3>
                <ul>
                  <li>UKCA</li>
                  <li>MDR</li>
                  <li>IVDR</li>
                </ul>
              </div>
            </div>

            <div className="services-section">
              <h3>Comprehensive Compliance Services</h3>
              <div className="services-grid">
                <div className="service-item">
                  <h4>DPIA and SRoC Documentation</h4>
                  <p>
                    Complete data protection impact assessments and security
                    documentation
                  </p>
                </div>

                <div className="service-item">
                  <h4>Data Flow Mapping</h4>
                  <p>
                    Comprehensive mapping of data movements and storage across
                    your systems
                  </p>
                </div>

                <div className="service-item">
                  <h4>NHS App Integration</h4>
                  <p>
                    Seamless integration with NHS digital services and platforms
                  </p>
                </div>

                <div className="service-item">
                  <h4>EHR and HIE Integration</h4>
                  <p>
                    Connect with Electronic Health Records and Health
                    Information Exchanges
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Case Studies & Proof Section */}
        <CaseStudiesSection
          caseStudies={{
            enabled: true,
            type: "clientStories",
            title: "Case Studies",
            subtitle: "",
            description: [
              {
                children: [
                  {
                    text:
                      "Real-world outcomes from our healthcare digital transformation projects across diverse healthcare sectors and use cases.",
                  },
                ],
              },
            ],
            ctaText: "View All Case Studies",
            ctaUrl: "/client-story",
          }}
        />

        {/* Leadership Spotlight */}
        <section className="leadership-spotlight">
          <div className="body-container">
            <RevealAnimation component="div" className="spotlight-content">
              <div className="spotlight-text">
                <div className="spotlight-badge">
                  <span className="badge-text">Leadership Spotlight</span>
                </div>
                <h2>Led by Healthcare Innovation Expert</h2>
                <p>
                  <strong>Dr. Baskar Raju, CEO & MD</strong> -
                  Surgeon-turned-tech CEO with deep healthcare domain expertise.
                  Former NHS Digital Innovation & Improvement Lead who
                  understands both clinical workflows and regulatory compliance
                  requirements.
                </p>
                <div className="spotlight-highlights">
                  <div className="highlight">
                    ✓ Clinical Background in Surgery
                  </div>
                  <div className="highlight">
                    ✓ NHS Digital Innovation Leadership
                  </div>
                  <div className="highlight">
                    ✓ Healthcare Regulatory Expertise
                  </div>
                  <div className="highlight">
                    ✓ Digital Transformation Strategy
                  </div>
                </div>
                <Button
                  label="Meet Dr. Baskar Raju"
                  variant="outlined"
                  color="primary"
                  customClassName="spotlight-cta"
                  onClick={() =>
                    (window.location =
                      "about-us/leadership?profile=Dr-Baskar-Raju")
                  }
                />
              </div>
              <div className="spotlight-image">
                <img src={BaskarImg} alt="Dr. Baskar Raju" />
              </div>
            </RevealAnimation>
          </div>
        </section>

        {/* Trusted Partners */}
        <div className="healthcare-partners">
          <TrustedPartner
            title={
              <>
                Trusted by Healthcare Leaders & <br />
                Innovation‑Driven Organisations
              </>
            }
            showAllBtn={false}
            imgContainerClassName="custom-gap trustedPartnerAnimation"
          />
        </div>

        {/* FAQs Section */}
        <FAQSection
          data={{
            enabled: true,
            title: "Healthcare FAQs",
            subtitle:
              "Get answers to common questions about our healthcare digital transformation services",
            faqs: [
              {
                question: "How do you handle data security & compliance?",
                answer: [
                  {
                    children: [
                      {
                        text:
                          "We embed privacy and security by design, aligning to HIPAA/HITECH, GDPR, ISO 27001, and DTAC standards. We operate on certified cloud platforms with 24×7 incident response capabilities to ensure your healthcare data remains secure and compliant.",
                      },
                    ],
                  },
                ],
              },
              {
                question: "Who do you serve in the healthcare ecosystem?",
                answer: [
                  {
                    children: [
                      {
                        text:
                          "We serve hospitals, clinics, pharmaceutical companies, med-tech organizations, and digital health founders across the UK & US. Our expertise spans from early-stage startups to enterprise healthcare organizations.",
                      },
                    ],
                  },
                ],
              },
              {
                question:
                  "How quickly can I see ROI from digital transformation?",
                answer: [
                  {
                    children: [
                      {
                        text:
                          "Healthcare startups typically see traction and measurable results within 6 months, while enterprise organizations can measure significant impact within 12 months. Our phased approach ensures early wins while building toward long-term transformation goals.",
                      },
                    ],
                  },
                ],
              },
              {
                question:
                  "What makes your healthcare technology approach different?",
                answer: [
                  {
                    children: [
                      {
                        text:
                          "We combine deep healthcare domain expertise with cutting-edge technology, focusing on patient outcomes, regulatory compliance, and operational efficiency. Our team includes healthcare professionals who understand both clinical workflows and technical implementation.",
                      },
                    ],
                  },
                ],
              },
              {
                question:
                  "Do you provide ongoing support after implementation?",
                answer: [
                  {
                    children: [
                      {
                        text:
                          "Yes, we offer comprehensive post-implementation support including 24/7 monitoring, regular updates, compliance audits, and continuous optimization. Our partnership approach ensures your healthcare technology evolves with changing regulations and patient needs.",
                      },
                    ],
                  },
                ],
              },
              {
                question:
                  "Can you help with NHS and US healthcare market entry?",
                answer: [
                  {
                    children: [
                      {
                        text:
                          "Absolutely. We have extensive experience with NHS Digital standards, NICE guidelines, and US healthcare regulations including FDA requirements. We can guide you through market entry strategies, regulatory approvals, and compliance frameworks for both markets.",
                      },
                    ],
                  },
                ],
              },
            ],
          }}
          disableDecor={false}
        />

        {/* Final CTA Section */}
        <section className="healthcare-final-cta">
          <div className="body-container">
            <RevealAnimation component="div" className="final-cta-content">
              <div className="cta-header">
                <h2>
                  Partner with DigiRyte to Turn Healthcare Ambition into
                  Operational Reality.
                </h2>
              </div>

              <div className="cta-buttons">
                <Button
                  label="Talk to Our Healthcare Experts"
                  variant="contained"
                  color="primary"
                  customClassName="cta-btn primary"
                  onClick={scrollToForm}
                />
                <Button
                  label="Speak to Dr. Baskar"
                  variant="outlined"
                  color="primary"
                  customClassName="cta-btn secondary"
                  onClick={() =>
                    window.open(
                      "https://calendly.com/baskar-digiryte/30min",
                      "_blank"
                    )
                  }
                />
              </div>

              <div className="trust-badges">
                <div className="trust-badge">
                  <img
                    src="/icons/hipaa-badge.svg"
                    alt="HIPAA Compliant"
                    onError={(e) => (e.target.style.display = "none")}
                  />
                  <span>HIPAA Compliant</span>
                </div>
                <div className="trust-badge">
                  <img
                    src="/icons/nhs-badge.svg"
                    alt="NHS DTAC Aligned"
                    onError={(e) => (e.target.style.display = "none")}
                  />
                  <span>NHS DTAC Aligned</span>
                </div>
                <div className="trust-badge">
                  <img
                    src="/icons/iso27001-badge.svg"
                    alt="ISO 27001"
                    onError={(e) => (e.target.style.display = "none")}
                  />
                  <span>ISO 27001</span>
                </div>
              </div>
            </RevealAnimation>
          </div>
        </section>

        {/* Contact Info */}
        <TwoColumnContactInfo
          TwoColumnContactInfoData={TwoColumnContactInfoData}
        />
      </div>
    </Layout>
  );
};

export default HealthcareLanding;
